import { render, staticRenderFns } from "./AssessmentJoinModal.vue?vue&type=template&id=19e3941e&"
import script from "./AssessmentJoinModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentJoinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports